/**************************************************
 * Nombre:       Formulario_Testimonio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, CalendarMonth, Flag, TitleOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOSEVENTO} from "../../Constantes";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoVideo from "../../Modulo_formularios/Componentes/IngresoVideo";

const Formulario_Testimonio = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Video Vertical</Typography>
                </Grid>



                <Grid container size={7}>
                    <IngresoVideo dato={'video'} {...props} />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSEVENTO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}/>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo'} dato={'titulo'} {...props}
                                  requerido={'El Titulo es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre de la persona'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Parrafo Uno'} dato={'parrafoUno'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Parrafo dos'} dato={'parrafoDos'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Testimonio